// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__zRbFA","boxTitle":"Qualiphy_boxTitle__3h52x","box":"Qualiphy_box__3zszF","toggleWrap":"Qualiphy_toggleWrap__17f9a"};